export enum SUPPORTED_PSP {
  STRIPE = 'STRIPE',
  ADYEN = 'ADYEN',
}

export type SupportedPsp = (typeof SUPPORTED_PSP)[keyof typeof SUPPORTED_PSP];
